import { html, LitElement } from 'lit'
import { customElement } from 'lit/decorators.js'

import styles from './style.scss'

const elementName = 'test-drive-badge'
@customElement(elementName)
export class TestDriveBadge extends LitElement {
  protected createRenderRoot(): HTMLElement | DocumentFragment {
    return this
  }

  render() {
    return html`
      <style>
        ${styles}
      </style>
      <div id="${elementName}">
        <div class="badge">TESTDRIVE</div>
      </div>
    `
  }
}
